// CSS Modules - component class name prefix: ShopCountrySwitcher__

<template>
  <div
    v-show="!loading"
    :class="[
      { ShopCountrySwitcher__container__active: this.countrySwitcherActive },
      $style.container
    ]"
  >
    <a
      :class="$style.toggle"
      v-tippy="tippyOptions"
      ref="tippy"
      @init="initTippy"
      @hide="toggleSwitcherInactive"
      @show="toggleSwitcherActive"
    >
      <img :src="config.flag" :alt="config.currentCountry" />
      <span>{{ config.currentCountry }}</span>
    </a>
    <span :class="$style.caret"></span>
    <div id="countrySwitcher" :class="$style.layer">
      <Button
        :class="$style.close"
        isClose
        colour="white"
        v-on:close="closeCountrySwitcher"
      />
      <div :class="$style.content">
        <Tabs :tabCount="1">
          <template v-slot:1-title>
            {{ config.title }}
          </template>
          <template v-slot:1-content>
            <div :class="$style.websites">
              <div :class="[$style.websitesControls, 'columns']">
                <div
                  class="column is-half-mobile is-one-third-tablet is-one-quarter-desktop is-one-fifth-widescreen"
                >
                  <Select
                    :key="`sitesKey-${componentKey}`"
                    :class="$style.regionSelect"
                    colour="blue"
                    :selectOptions="siteSelectOptions"
                    :selectValue="siteSelectValue"
                    @onChange="updateCountryButtons"
                  />
                </div>
              </div>
              <div :class="$style.countries">
                <div v-for="(country, index) in countryButtons" :key="index">
                  <CountryButton
                    :country="country.name"
                    :flag="country.flag"
                    :languages="country.languages"
                  />
                </div>
              </div>
            </div>
          </template>
        </Tabs>
      </div>
    </div>
  </div>
</template>

<script>
// import { isMobile } from "mobile-device-detect";
import Button from "../Button/Button.vue";
import CountryButton from "../CountryButton/CountryButton.vue";
import Select from "../Select/Select.vue";
import Tabs from "../Tabs/Tabs.vue";
import { regionDataUrl } from "../../shared/globals";
import getShopRegionsFromUrl from "../../xhr/shopHeader/getShopRegionsFromUrl";

export default {
  name: "ShopCountrySwitcher",
  components: {
    Button,
    CountryButton,
    Select,
    Tabs
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loading: true,
      componentKey: 0,
      apiData: null,
      availableSites: [],
      siteSelectOptions: [],
      siteSelectValue: "",
      countryButtons: [],
      countrySelectOptions: [],
      countrySelectValue: "",
      countrySwitcherActive: false,
      tippyOptions: {
        theme: "wika light",
        interactive: true,
        reactive: true,
        placement: "bottom",
        flip: false,
        animation: "fade",
        duration: [200, 600],
        animateFill: false,
        arrow: true,
        distance: 7,
        zIndex: 10000,
        html: "#countrySwitcher",
        trigger: "click" //isMobile ? "click" : "mouseenter focus"
      }
    };
  },
  methods: {
    forceRerender() {
      this.componentKey += 1;
    },
    initTippy(tippy) {
      tippy.popper.id = "countrySwitcherPopper";
    },
    toggleSwitcherActive() {
      this.countrySwitcherActive = true;
    },
    toggleSwitcherInactive() {
      this.countrySwitcherActive = false;
    },
    closeCountrySwitcher() {
      this.$refs.tippy._tippy.hide();
    },
    setSiteSelectOptions() {
      this.availableSites = this.apiData.regions.filter(region => {
        return (
          region.countries.findIndex(
            country => country.languages && country.languages.length
          ) > -1
        );
      });
      this.siteSelectOptions = this.availableSites.map(site => site.name);
    },
    setCountrySelectOptions() {
      let foundRegion = this.siteSelectOptions[0];
      this.countryButtons = [];

      if (this.config.currentRegion) {
        foundRegion =
          this.availableSites.find(
            region => region.name === this.siteSelectValue
          ) || foundRegion;
      }

      this.countrySelectOptions = foundRegion.countries.map(country => {
        this.setCountryButtons(country);
        return country.name;
      });
    },
    setCountryButtons(country) {
      if (country.flag && country.languages && country.languages.length !== 0) {
        this.countryButtons.push(country);
      }
    },
    initApiData(data) {
      this.apiData = data;
      this.siteSelectValue = this.config.currentRegion;
      this.countrySelectValue = this.config.currentCountry;
      this.setSiteSelectOptions();
      this.setCountrySelectOptions();
      this.forceRerender();
    },
    updateCountryButtons(value) {
      this.siteSelectValue = value;
      this.setCountrySelectOptions();
    }
  },
  mounted() {
    let dataUrl = "";
    window.shopRegionDataUrl
      ? (dataUrl = window.shopRegionDataUrl)
      : (dataUrl = regionDataUrl);

    if (dataUrl) {
      getShopRegionsFromUrl(dataUrl)
        .then(responseData => this.initApiData(responseData))
        .catch(error => console.error(error))
        .finally(() => (this.loading = false));
    } else {
      console.error("Error: Region data url is missing.");
    }
  }
};
</script>

<style module lang="scss">
@import "../CountrySwitcher/CountrySwitcher.scss";
</style>
